import React, { useState } from 'react';
import { ModalHeader } from 'styled_components/Common/ModalHeader';
import { RESOLUTIONS } from 'services/config';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { TourBody } from './TourBody';

const CDN_URL = process.env.REACT_APP_CDN_URL;

const StartTourStyle = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 160px;
	z-index: 4600;
	cursor: pointer;
	.title {
		margin-left: 8px;
	}
	img {
		width: 20px;
		height: 20px;
	}
	#start-tour-container {
		position: absolute;
		width: 160px;
		min-width: 160px;
		height: 40px;
		bottom: 80px;
		left: 0px;
		display: flex;
		align-items: center;
		justify-content: center;
		&.alert-present {
			bottom: 120px;
		}
	}
	#start-tour-container-portal {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 160px;
		min-width: 160px;
		height: 40px;
		bottom: 120px;
		&.alert-present {
			bottom: 160px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 192px;
		img {
			width: 32px;
			height: 32px;
		}
		#start-tour-container {
			&.alert-present {
				bottom: 164px;
			}
		}
		#start-tour-container-portal {
			width: 192px;
			height: 50px;
			bottom: 164px;
			&.alert-present {
				bottom: 228px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 320px;

		.title {
			margin-left: 16px;
		}
		img {
			width: 32px;
			height: 32px;
		}
		#start-tour-container {
			width: 320px;
			height: 80px;
			bottom: 160px;
			&.alert-present {
				bottom: 240px;
			}
		}
		#start-tour-container-portal {
			width: 320px;
			height: 80px;
			bottom: 240px;
			&.alert-present {
				bottom: 320px;
			}
		}
	}
`;

function getSize(breakpoint) {
	let size = 'medium';

	if (breakpoint === RESOLUTIONS.MED) {
		size = 'medium';
	} else if (breakpoint === RESOLUTIONS.HIGH) {
		size = 'medium';
	}

	return size;
}

function getHeader(module) {
	return (
		<ModalHeader
			image={`${CDN_URL}common/tour-icon-${module}.svg`}
			text={'Which tour you would like to view.'}
			className='guest'
		/>
	);
}

function onMouseOver(module) {
	const image = document.getElementById('tour-image');
	image.src = `${CDN_URL}common/tour-icon-hover-${module}.svg`;
}
function onMouseOut(module) {
	const image = document.getElementById('tour-image');
	image.src = `${CDN_URL}common/tour-icon-${module}.svg`;
}

export const StartTour = ({
	id,
	cypressId,
	breakpoint,
	stepIndex,
	hasBillingAccess,
	hasProfileAccess,
	hasStorageAccess,
	hasSupportAccess,
	hasUserManagementAccess,
	module,
}) => {
	const [showModal, setShowModal] = useState(false);
	const navigate = useNavigate();

	function startTour(url, state) {
		setShowModal(false);
		navigate(url, state);
	}
	return (
		<StartTourStyle>
			<div
				id={id}
				className={`tour-container ${module}`}
				data-cy={cypressId}
				onMouseOver={() => onMouseOver(module)}
				onMouseOut={() => onMouseOut(module)}
				onClick={() => setShowModal(true)}
			>
				<img id='tour-image' src={`${CDN_URL}common/tour-icon-${module}.svg`} />
				<div className='title header10'>SITE TOURS</div>
			</div>
			<PortraitModalComponent
				closeModal={setShowModal}
				show={showModal}
				header={getHeader(module)}
				title='SITE TOURS'
				subTitle={`Tour Selection`}
				size={getSize(breakpoint)}
			>
				<TourBody
					startTour={startTour}
					stepIndex={stepIndex}
					hasBillingAccess={hasBillingAccess}
					hasProfileAccess={hasProfileAccess}
					hasStorageAccess={hasStorageAccess}
					hasSupportAccess={hasSupportAccess}
					hasUserManagementAccess={hasUserManagementAccess}
				/>
				<ModalFooter
					cypressId='footer'
					id='footer'
					buttonText1='Accept'
					buttonActive1={true}
					module={module}
					//buttonFunction1={() => {}}
					size={getSize(breakpoint)}
					//buttonFunction2={() => {}}
				/>
			</PortraitModalComponent>
		</StartTourStyle>
	);
};
